import IndividualList from './IndividualList';
import IndividualShow from './IndividualShow';

export default {
  list: IndividualList,
  show: IndividualShow,
};
